export const Types = {
    LOGIN: 'LOGIN',
    LOGOUT: 'LOGOUT',
    SELECT_COMPANY: 'SELECT_COMPANY',
    CHANGE_COMPANY: 'CHANGE_COMPANY'
  }